// extracted by mini-css-extract-plugin
module.exports = {"main-title":"plan-comparison-header_main-title__Dz_2s","subtitle":"plan-comparison-header_subtitle__g35VV"};